import { Tool } from "assistant-stream";

// TODO re-add the inferrence of the parameters

export function tool<TArgs extends Record<string, unknown>, TResult = any>(
  tool: Tool<TArgs, TResult>,
): Tool<TArgs, TResult> {
  return tool;
}
